module.exports = __webpack_public_path__ + "img/will-pets.21de6a0f.svg";